import React from 'react';
import styled, { css } from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

import { trackingId, useResponsiveCtx } from '@blueprint/ui';

import { cssToggleIconState } from '../Icon';
import Text from './Text';

/**
 * Link
 */
const Link = styled(Text).attrs({
  as: 'a',
})`
  text-decoration: ${(props) => (props.underline ? 'underline' : 'none')};
  cursor: pointer;

  &:hover,
  &:focus,
  &:active,
  &.active {
    text-decoration: underline;
  }
  ${(props) => themeGet(`typography.links.${props.mode}`)}
  ${(props) =>
    props.icon &&
    css`
      display: flex;
      flex-direction: row;
      align-items: center;
      ${cssToggleIconState(props.icon, ['hover', 'active', 'focus'])};
    `}
`;

Link.defaultProps = {
  variant: 'body1',
  'data-testid': 'Link',
  'data-trackid': trackingId('Link'),
};

Link.displayName = 'Link';

export default Link;

export const ResponsiveLink = (props) => {
  const { hMedia } = useResponsiveCtx();

  return <Link hMedia={hMedia} {...props} />;
};
